import React, { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';
import { toast } from 'react-toastify';

const GuestRoute = ({ children }) => {
  const { isLoggedIn, authChecked } = useAuth();
  const toastShownRef = useRef(false);

  useEffect(() => {
    if (!authChecked) return;
    if (isLoggedIn && !toastShownRef.current) {
      toast.info('You are already logged in.');
      toastShownRef.current = true;
    }
  }, [authChecked, isLoggedIn]);

  if (!authChecked) return <Loader />;
  if (isLoggedIn) return <Navigate to="/profile" replace />;

  return children;
};

export default GuestRoute;
